module.exports = __webpack_public_path__ + "img/banner_4.9332e45f.jpg";